// zod schemas for pair-flow forms (per W2 §4.3 + §6.2).

import { z } from "zod";

import { isOnOrBeforeToday } from "@/lib/utils/date";

const INVITE_CODE_REGEX = /^[1-9][0-9]{5}$/;
const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const inviteCodeSchema = z.object({
  code: z.string().regex(INVITE_CODE_REGEX, "邀請碼為 6 位數字, 第一位非 0"),
});

export const acceptInviteSchema = z
  .object({
    code: z.string().regex(INVITE_CODE_REGEX, "邀請碼為 6 位數字, 第一位非 0"),
    pair_name: z
      .string()
      .min(1, "情侶名稱至少 1 字")
      .max(50, "情侶名稱最長 50 字")
      .optional()
      .or(z.literal("")),
    relationship_start: z
      .string()
      .regex(DATE_REGEX, "日期格式為 YYYY-MM-DD")
      .optional()
      .or(z.literal(""))
      .refine((s: unknown) => {
        if (typeof s !== "string" || !s) return true;
        return isOnOrBeforeToday(s);
      }, "日期不可晚於今天"),
  })
  .refine(
    (v: { pair_name?: string; relationship_start?: string }) => v.pair_name || v.relationship_start,
    {
      message: "請設定情侶名稱或交往紀念日 (至少一項)",
      path: ["pair_name"],
    },
  );

export const patchPairSchema = z
  .object({
    name: z.string().min(1, "情侶名稱至少 1 字").max(50, "最長 50 字").optional(),
    relationship_start: z.string().regex(DATE_REGEX, "日期格式為 YYYY-MM-DD").optional(),
  })
  .refine((v: { name?: string; relationship_start?: string }) => v.name || v.relationship_start, {
    message: "請至少修改一個欄位",
    path: ["name"],
  });

export const dissolveConfirmSchema = z.object({
  confirm_pair_name: z.string().min(1, "請輸入情侶名稱以確認"),
});

export type InviteCodeInput = z.infer<typeof inviteCodeSchema>;
export type AcceptInviteInput = z.infer<typeof acceptInviteSchema>;
export type PatchPairInput = z.infer<typeof patchPairSchema>;
export type DissolveConfirmInput = z.infer<typeof dissolveConfirmSchema>;
